import React from 'react'

const termsOfUse = props => {
    return (
        <section className="home_hero FlexVrCenter" style={{padding: '0', height: '100%'}}>
            <embed src="/custom_docs/UserAgreement/AV_Hero_Terms_of_Use.pdf" width="100%" height="100%" />
        </section>
    )
}

export default termsOfUse